export default {
  "backToStart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to start"])},
  "proceed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next"])},
  "emailRegisteration": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign up for our newsletter"])},
    "invalidEmail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please enter a valid email!"])},
    "emailAddress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail Address..."])}
  },
  "interestedLanguages": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Which languages are you interested in?"])},
    "any": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All"])},
    "AFew": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A few"])}
  },
  "selectlanguages": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select the languages you are interested in ..."])}
  },
  "personalDescriptions": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["What best describes you?"])},
    "teacher": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I'm a teacher"])},
    "librarian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I'm a librarian"])},
    "purchaser": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I'm a purchaser"])},
    "other": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Other"])}
  },
  "sendInformation": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Do you want us to send information about our company or only about books that we think are interesting?"])},
    "yeahSure": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please do"])},
    "noThanks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Only about books"])}
  },
  "askedcontact": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Can we contact you to learn more about your needs? It helps us improve our assortment and service."])},
    "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes, please call"])},
    "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No, thanks"])}
  },
  "phoneNumberRegisteration": {
    "phoneNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter a phone number..."])}
  },
  "thankYou": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Thank you!"])},
    "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You have now subscribed"])}
  },
  "recaptcha": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please confirm to subscribe"])}
  }
}